import { Typography, css, styled } from "@mui/material";

import { getColor } from "@hooks/useColors";

export type CardType = "problem" | "technology";

interface CardContainerProps {
  type: CardType;
}

export const CardContainer = styled("div", {
  shouldForwardProp: prop => prop !== "type",
})<CardContainerProps>(
  ({ type, theme }) => css`
    display: flex;
    flex-direction: column;

    position: relative;

    width: 100%;
    border-radius: ${type === "problem" ? "12px" : "24px"};
    border: 1px solid ${getColor(c => c.tokens.stroke["soft-200"], theme)};

    background: ${getColor(c => c.tokens.bg["soft-200"], theme)};

    ${theme.breakpoints.up("mobile")} {
      padding: ${type === "problem" ? "0.5rem" : "1rem"} 1rem 1rem 1rem;
      gap: 1rem;
    }

    ${theme.breakpoints.up("tablet")} {
      padding: ${type === "problem" ? "0.5rem 1rem 1rem 1rem" : "1.5rem 1rem"};
      gap: 1rem;
    }

    ${theme.breakpoints.up("desktopXl")} {
      padding: ${type === "problem" ? "1rem" : "1.5rem"};
      gap: ${type === "problem" ? "1rem" : "2rem"};
    }
  `,
);

export const CardShadow = styled("div")(
  ({ theme }) => css`
    position: absolute;
    height: calc(100% - 64px);
    width: calc(100% - 64px);
    z-index: -1;
    top: 32px;
    left: 32px;
    ${theme.card?.shadow
      ? css`
          background-color: ${theme.card?.shadow};
        `
      : ""};
    border-radius: 24px;
    opacity: 70%;
    filter: blur(25px);
  `,
);

export const TextIcon = styled("p")(
  ({ theme }) => css`
    margin: 0;
    font-family:
      Work Sans,
      Arial,
      Helvetica,
      sans-serif;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    color: ${getColor(c => c.tokens.text["strong-950"], theme)};
  `,
);

export const CardDescription = styled(Typography)(
  ({ theme }) => css`
    color: ${getColor(c => c.tokens.text["sub-600"], theme)};
    & p {
      margin: 0;
    }
  `,
);
